const API_BASE_URL = '/api';

export const searchMovies = async (query) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/search?query=${encodeURIComponent(query)}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to search movies');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
}; 